import moment from 'moment';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table'; // see https://github.com/xaksis/vue-good-table
import 'vue-good-table/dist/vue-good-table.css';
import { Component } from 'vue-property-decorator';
import DatePicker from 'vuejs-datepicker';
import { formatDateTime, WindowType } from '../../util';
import { ShiftTime } from './oeeshift.model';
import ShiftService from './oeeshift.service';

declare var window: WindowType;

@Component({
    name: 'shift',
    components: {
        VueGoodTable,
        DatePicker
    },
})
export default class ShiftComponent extends Vue {
    service: ShiftService = new ShiftService();
    oeeSettingsPage: ShiftTime[] = [];
    selectedIndex: ShiftTime[] = [];
    newSetting: ShiftTime = new ShiftTime();
    isMaintenance: boolean = true;
    startOfDay: Date = moment().clone().startOf('day').toDate();
    endOfDay: Date = moment().clone().startOf('day').add('day', 1).toDate();

    start: Date = this.startOfDay;

    columnsConfig = [
        {
            label: 'Name',
            field: 'name',
        },
        {
            label: 'Hour - S1',
            field: 'hour',
        },
        {
            label: 'Minute - S1',
            field: 'min',
        },
        {
            label: this.getStrTime(),
            field: 'start',
            type: 'date',
            formatFn: formatDateTime
        }
    ];
    selectConfig = {
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: this.getSelectionTextStr(),
        clearSelectionText: this.getClearStr(),
        disableSelectInfo: false, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
    };

    constructor() {
        super();
        this.selectedIndex = [];
    }

    mounted() {
        this.isMaintenance = window.application.check2.isMaintenanceMode
        this.fetchSettings();
    }

    fetchSettings() {
        this.service.fetchsettings()
            .then(data => {
                this.oeeSettingsPage = data as ShiftTime[];
                console.log(this.oeeSettingsPage);
            });
    }

    postSetting() {
        console.log("post shift");
        this.newSetting.start = this.start.toDateString();
        this.service.postsetting(this.newSetting);
        this.fetchAndClear();
    }

    deleteSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.deletesettings(this.selectedIndex);
            this.fetchAndClear();
        }
    }

    updateSelected() {
        if (this.selectedIndex.length > 0) {
            this.service.updatesetting(this.selectedIndex[0]);
            this.fetchAndClear();
        }
    }

    clearSelection() {
        this.selectedIndex = [];
    }

    // Fetches the data after 1 second and also clears the inputs etc.s
    fetchAndClear() {
        // Create a new Promise and resolve after 1 seconds
        var myTimerPromise = new Promise((resolve, reject) => {
            setTimeout(resolve, 500);  // "resolve" is already a function, no need for another anonymous function here
        });

        // Fetch data now, within Promise.all()
        Promise.all([myTimerPromise]).then(() => {
            this.fetchSettings();
            this.clearSelection();
            this.newSetting = new ShiftTime();
        });
    }

    selectionChanged(params) {
        console.log("selection items=" + JSON.stringify(params));
        this.selectedIndex = params.selectedRows;
    }

    getClearStr() {
        return this.$i18n.t('comClear').toString();
    }

    getSelectionTextStr() {
        return this.$i18n.t('comSelectionCnt').toString();
    }

    getStrTime() {
        return this.$i18n.t('txtOEEShiftStart').toString();
    }
}